<template>
  <div class="row f-row mt-1 no_nav_tut_height">
    <div class="col col-12 h-100">
      <div class="row f-row justify-content-center">
        <div class="col col-1">
          <div class="row f-row">
            <div class="col col-1 text-left">
              <button
                type="button"
                class="btn btn-candle"
                :disabled="currentPage <= 1"
                v-on:click="currentPage = currentPage - 1"
              >
                <i class="fa fa-chevron-left"></i>
              </button>
            </div>
            <div class="col col-4 text-center">
              <InputNumber
                :inputClass="'input90Size'"
                :tableFormat="true"
                v-model="currentPage"
              />
            </div>
            <div class="col col-2 text-center">/</div>
            <div
              class="col col-4 text-center"
              style="font-size:0.9rem; padding-top: 4px;"
            >
              {{ pageCount }}
            </div>
            <div class="col col-1 text-right">
              <button
                type="button"
                class="btn btn-candle"
                :disabled="currentPage >= pageCount"
                v-on:click="currentPage = currentPage + 1"
              >
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col col-1"></div>
        <div class="col col-8">
          <div
            class="btn-toolbar"
            role="toolbar"
            aria-label="Toolbar with button groups"
          >
            <div class="btn-group btn-group-toggle btn-block" role="group">
              &nbsp;
              <button
                v-for="(btnData, index) in pdfButtons"
                :value="btnData"
                :key="index"
                type="button"
                class="btn btn-candle"
                style="width: 20px"
                v-on:click="currentPage = btnData['page']"
                v-bind:class="[
                  currentPage >= btnData['page'] &&
                  currentPage < btnData['endPage']
                    ? 'active'
                    : ''
                ]"
              >
                {{ btnData["name"] }}
              </button>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
      <div
        class="row f-row mt-1 no_nav_tut_height_2 justify-content-center"
        id="pdf_div"
      >
        <div
          class="h-100"
          :style="{ width: '' + pdfSize + '%' }"
          style="border: 1px solid var(--lightbackground);"
        >
          <pdf
            :src="pdfName"
            :page="currentPage"
            style="display: inline-block; width: 100%;"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
          ></pdf>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputNumber from "primevue/inputnumber";
import pdf from "vue-pdf"; // https://www.npmjs.com/package/vue-pdf

export default {
  name: "PDFDisplay",
  components: {
    InputNumber,
    pdf
  },
  props: {
    pdfButtons: { required: true, default: () => [] },
    pdfName: { required: true, default: "" }
  },
  data() {
    return {
      currentPage: 1,
      pdfSize: 1
    };
  },
  computed: {
    pageCount() {
      let nLen = this.pdfButtons.length - 1;
      return this.pdfButtons[nLen]["endPage"];
    }
  },
  mounted() {
    let screenSize = document.getElementById("pdf_div");
    this.pdfSize =
      (100 * screenSize.clientHeight) /
      ((screenSize.clientWidth * 1078) / 1916);
  }
};
</script>

<style scoped></style>
